import { Controller } from "react-hook-form"
import { LassoTextField } from "../LassoTextField"

export const LassoFormField = (props: any ) => {
    return (
        <Controller
            {...props.controller}
            render={({ field }) => (
                <LassoTextField
                    {...field}
                    {...props}
                    onChange = {props.onChange? (e: any) => props.onChange(e, field): field.onChange}
                />
                        
            )}
        />
    )
}